import React from "react";
import { positions } from "../../../data/CompanyData";
import { BsCircleFill, BsClock } from "react-icons/bs";
import { IoLocationOutline } from "react-icons/io5";
const OurPosition = () => {
  return (
    <div className=" py-10">
      <div className="space-y-1">
        <p className="text-primary text-sm font-semibold">Open position</p>
        <h3 className="text-xl font-bold text-black">
          We're looking for talented people
        </h3>
        <p className="text-md text-accent">
          We're a 100% remote team spread all across the world . Join us
        </p>
      </div>
      <div className="grid lg:grid-cols-2 gap-10 grid-cols-1 mt-10">
        <ul className="space-y-5 ">
          {positions.slice(0, 3).map((item, index) => (
            <li
              key={index}
              className="border-t border-t-gray-200 py-4 space-y-3"
            >
              <h3 className="text-lg font-bold text-black flex items-center">
                {item.title}{" "}
                <span
                  style={{ background: item.bg, color: item.color }}
                  className={`flex items-center font-semibold text-xs ml-1 px-2 py-1 rounded-full`}
                >
                  <span>
                    <BsCircleFill className="text-[7px] mr-1" />
                  </span>{" "}
                  <span>{item.options}</span>
                </span>
              </h3>

              <p className="text-accent text-sm">{item.text}</p>
              <div className="text-accent text-sm flex gap-3 items-center">
                <span className="flex items-center gap-1">
                  <IoLocationOutline /> {item.site}
                </span>
                <span className="flex items-center gap-1">
                  <BsClock />
                  {item.time}
                </span>
              </div>
            </li>
          ))}
        </ul>
        <ul className="space-y-5 ">
          {positions.slice(3, 6).map((item, index) => (
            <li
              key={index}
              className="border-t border-t-gray-200 py-4 space-y-3"
            >
              <h3 className="text-lg font-bold text-black flex items-center">
                {item.title}{" "}
                <span
                  style={{ background: item.bg, color: item.color }}
                  className={`flex items-center font-semibold text-xs ml-1 px-2 py-1 rounded-full`}
                >
                  <span>
                    <BsCircleFill className="text-[7px] mr-1" />
                  </span>{" "}
                  <span>{item.options}</span>
                </span>
              </h3>
              <p className="text-accent text-sm">{item.text}</p>
              <div className="text-accent text-sm flex gap-3 items-center">
                <span className="flex items-center gap-1">
                  <IoLocationOutline /> {item.site}
                </span>
                <span className="flex items-center gap-1">
                  <BsClock />
                  {item.time}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OurPosition;
